"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GoogleMapsBox_1 = __importDefault(require("./components/GoogleMapsBox"));
var LocationFinderFilter_1 = __importDefault(require("./components/LocationFinderFilter"));
document.addEventListener('DOMContentLoaded', function () {
    new GoogleMapsBox_1.default();
    new LocationFinderFilter_1.default();
});
